import { KeyboardAvoidingView, ScrollView, View } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"

import { Vertical } from "@/components/standard/BFLayout"
import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { LoanAddressHeader } from "@/screens/loans/components/LoanAddressHeader"
import { BFBackButton } from "@/components/standard/BFBackButton"
import FullScreenBackground from "@/components/backgrounds/FullScreenBackgroundGradient"
import React from "react"

export default function LoanDashboardDetailsLayout({
  loanId,
  children,
}: {
  loanId: string
  children: React.ReactNode
}) {
  const insets = useSafeAreaInsets()

  const propertyQuery = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return data?.property
    },
  })

  const property = propertyQuery.data

  if (!property) {
    return null
  }
  return (
    <KeyboardAvoidingView
      testID="LoanDashboardDetailsScreen"
      className="flex flex-col flex-1"
      behavior="padding"
    >
      <FullScreenBackground />
      <View style={{ paddingTop: 12 + insets.top }} className={"px-5 gap-3"}>
        <View className={"relative"}>
          <LoanAddressHeader address={property} />
          <BFBackButton className={"absolute top-1"} />
        </View>
      </View>
      <Vertical className="flex-1 bg-off-white">
        <ScrollView
          className="flex-1 bg-off-white"
          contentContainerStyle={{
            paddingBottom: insets.bottom,
          }}
        >
          {children}
        </ScrollView>
      </Vertical>
    </KeyboardAvoidingView>
  )
}
